// extracted by mini-css-extract-plugin
export default {"_hy":"_hy","main":"loader-module_main_y5c","spinner":"loader-module_spinner_ZSh"};